import { Loader } from '@lightbeamai/design-system'
import React, { useEffect } from 'react'
import { useLocation } from 'react-router-dom'

export const MS_VIVA_ENGAGE_CODE_EVENT = 'MsVivaEngageCode'
export const MS_VIVA_ENGAGE_CODE_PROCESSED_EVENT = 'MsVivaEngageCodeProcessed'

export type MsVivaEngageCallbackMessage = {
  code?: string
  type: string
}

export function MsVivaEngageCallback() {
  const location = useLocation()

  const code = new URLSearchParams(location.search).get('code')

  useEffect(() => {
    const handleMessage = (event: MessageEvent) => {
      if (event.origin !== window.location.origin) {
        return
      }

      if (event.data.type === MS_VIVA_ENGAGE_CODE_PROCESSED_EVENT) {
        window.close()
      }
    }

    window.addEventListener('message', handleMessage, false)

    return () => {
      window.removeEventListener('message', handleMessage, false)
    }
  }, [])

  useEffect(() => {
    if (code && window.opener) {
      window.opener.postMessage({ code, type: MS_VIVA_ENGAGE_CODE_EVENT }, window.location.origin)
    }
  }, [code])

  return (
    <div className="flex flex-col w-full xs-mt-64">
      <Loader size={48} loading />
    </div>
  )
}
